var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#f9cc4e",
    height: 74.905,
    rx: 8.069,
    width: 115.387,
    x: 6.306,
    y: 26.547
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.69 34.62v9.46h-115.38v-9.46a8.066 8.066 0 0 1 8.07-8.07h99.24a8.066 8.066 0 0 1 8.07 8.07z",
    fill: "#6d7a84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.021 57.797h29.941v29.941h-29.941z",
    fill: "#e2e8ed"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.991,
    cy: 69.833,
    fill: "#f95050",
    r: 5.255
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.285 87.738v-4.944a7.706 7.706 0 0 1 7.706-7.706 7.707 7.707 0 0 1 7.709 7.706v4.944z",
    fill: "#f95050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.375 26.547v31.25l-8.503-8.503-8.503 8.503v-31.25z",
    fill: "#4ec4b5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e2e8ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107.979 89.488h-42.374a1.75 1.75 0 0 1 0-3.5h42.374a1.75 1.75 0 0 1 0 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.979 79.473h-42.374a1.75 1.75 0 0 1 0-3.5h42.374a1.75 1.75 0 0 1 0 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.979 69.369h-42.374a1.75 1.75 0 0 1 0-3.5h42.374a1.75 1.75 0 1 1 0 3.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.2583d3134279761950a9e9329f684e31.svg";
export { ForwardRef as ReactComponent };